import React, { useState } from 'react';
import qs from 'query-string';

import {
  Block,
} from '@uncinc/react-drupal-core';

import { BLOCK_DONATION_BLOCK_ID } from '../../../config/constants';

const ParagraphHeroCarouselItemDonation = ({ entity }) => {
  const [amountSelected, setAmountSelected] = useState(null);
  const [intervalSelected, setIntervalSelected] = useState(null);

  const title = entity.getIn(['field_title', 0, 'value'], '');
  const linkUrl = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const linkTitle = entity.getIn(['field_link', 0, 'title'], '');

  const linkUrlComplete = qs.stringifyUrl({
    url: linkUrl,
    query: {
      amount: amountSelected,
      interval: intervalSelected,
    },
  });

  return (
    <div className="ParagraphHeroCarouselItemDonation">
      <Block
        id={BLOCK_DONATION_BLOCK_ID}
        props={{ title, linkUrlComplete, linkTitle, amountSelected, intervalSelected }}
        setAmountSelected={setAmountSelected}
        setIntervalSelected={setIntervalSelected}
      />
    </div>
  );
};

export default ParagraphHeroCarouselItemDonation;
